import { useCallback, useSyncExternalStore } from "react";

export const useMediaQuery = (query: string, fallback = false) => {
  const subscribe = useCallback((listener: () => void) => {
    const list = window.matchMedia?.(query);
    list?.addEventListener("change", listener);
    return () => list?.removeEventListener("change", listener);
  }, [query]);

  return useSyncExternalStore(subscribe, () => window.matchMedia?.(query).matches ?? fallback);
};
